function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React from "react";
export function useMulti(props, dateLib) {
  var initiallySelected = props.selected,
    required = props.required,
    onSelect = props.onSelect,
    mode = props.mode;
  var _React$useState = React.useState(initiallySelected),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selected = _React$useState2[0],
    setSelected = _React$useState2[1];
  var isSameDay = dateLib.isSameDay;
  // Update the selected date if the selected value from props changes.
  React.useEffect(function () {
    setSelected(initiallySelected);
  }, [mode, initiallySelected]);
  var isSelected = function isSelected(date) {
    var _selected$some;
    return (_selected$some = selected === null || selected === void 0 ? void 0 : selected.some(function (d) {
      return isSameDay(d, date);
    })) !== null && _selected$some !== void 0 ? _selected$some : false;
  };
  var min = props.min,
    max = props.max;
  var select = function select(triggerDate, modifiers, e) {
    var newDates = _toConsumableArray(selected !== null && selected !== void 0 ? selected : []);
    if (isSelected(triggerDate)) {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === min) {
        // Min value reached, do nothing
        return;
      }
      if (required && (selected === null || selected === void 0 ? void 0 : selected.length) === 1) {
        // Required value already selected do nothing
        return;
      }
      newDates = selected === null || selected === void 0 ? void 0 : selected.filter(function (d) {
        return !isSameDay(d, triggerDate);
      });
    } else {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === max) {
        // Max value reached, reset the selection to date
        newDates = [triggerDate];
      } else {
        // Add the date to the selection
        newDates = [].concat(_toConsumableArray(newDates), [triggerDate]);
      }
    }
    onSelect === null || onSelect === void 0 || onSelect(newDates, triggerDate, modifiers, e);
    setSelected(newDates);
    return newDates;
  };
  return {
    selected: selected,
    select: select,
    isSelected: isSelected
  };
}